import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import cusHeader from '@/components/cus-header/cus-header' //主框架
Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.component('cus-header', cusHeader)
new Vue({
	router,
	render: h => h(App),
}).$mount('#app')